import { render, staticRenderFns } from "./FPotensIKawasanUtilitas.vue?vue&type=template&id=d54ec014&scoped=true"
import script from "./FPotensIKawasanUtilitas.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanUtilitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54ec014",
  null
  
)

export default component.exports